module.exports = __webpack_public_path__ + "static/media/btn_album_before5170534b6afaccf722c351c2e8910865.webp";